import { useEffect, useRef } from 'react';
import isEqual from 'lodash/isEqual';

const useDeepEffect = (fn: Function, deps: any[]) => {
  const isFirst = useRef(true);
  const prevDeps = useRef(deps);

  useEffect(() => {
    const isSame = prevDeps.current.every((obj, index) => isEqual(obj, deps[index]));

    if (isFirst.current || !isSame) {
      fn();
    }

    isFirst.current = false;
    prevDeps.current = deps;
    // eslint-disable-next-line
  }, deps);
};

export default useDeepEffect;
